import { RouteConfig } from 'react-router-config'
import AsyncComponent from './AsyncComponent'

const routes: RouteConfig[] = [
  {
    path: '/production-license',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: 'production-license' */ '../@production-license')
    ),
  },
]

export default routes
